/**
* @prop --uic-scroll-picker-min-width: Min width of component
* @prop --uic-scroll-picker-outline: Outline styling
* @prop --uic-scroll-picker-outline-offset: Outline offset
* @prop --uic-scroll-picker-border: Border style (should match outline offset)
* @prop --uic-scroll-picker-top-gradient: Gradient for overlay on top
* @prop --uic-scroll-picker-bottom-gradient: Gradient for overlay on bottom
* @prop --uic-scroll-picker-select-options-color: Font color for the items
* @prop --uic-scroll-picker-unit-padding: Padding used when a unit is set
* @prop --uic-scroll-picker-unit-font-size: Unit font size
* @prop --uic-scroll-picker-unit-font-weight: Unit font weight
* @prop --uic-scroll-picker-selected-item-background-color: Background color of the selected item
* @prop --uic-scroll-picker-selected-item-border: Top and bottom border styling of the selected item
* @prop --uic-scroll-picker-selected-item-color: Font color of the selected item
* @prop --uic-scroll-picker-selected-item-disabled-color: Font color of the selected item in disabled state
* @prop --uic-scroll-picker-selected-font-size: Font size of the selected item
* @prop --uic-scroll-picker-selected-font-weight: Font weight of the selected item
*/
uic-scroll-picker {
  display: inline-block;
  min-width: var(--uic-scroll-picker-min-width);
  outline-color: none;
  user-select: none;
}

.uic-scroll-picker {
  &.disabled {
    opacity: 0.5;
    pointer-events: none;

    .highlight {
      color: var(--uic-scroll-picker-selected-item-disabled-color);
    }
  }

  &:hover {
    .highlight {
      border: var(--uic-scroll-picker-selected-item-border);
      color: var(--uic-scroll-picker-selected-item-color);
    }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .select-wrap {
    align-items: center;
    border: var(--uic-scroll-picker-border);
    display: flex;
    overflow: hidden;
    position: relative;
    text-align: center;

    &:focus {
      outline: none;
      outline-offset: 0;

      .highlight {
        color: var(--uic-scroll-picker-selected-item-color);
        outline: var(--uic-scroll-picker-outline);
        outline-offset: var(--uic-scroll-picker-outline-offset);
      }
    }

    &:active {
      .highlight {
        color: var(--uic-scroll-picker-selected-item-color);
      }

      .highlight-background {
        background-color: var(--uic-scroll-picker-selected-item-background-color);
      }
    }

    &::before,
    &::after {
      content: '';
      display: block;
      height: 50%;
      position: absolute;
      width: 100%;
      z-index: 1;
    }

    &::before {
      background-image: var(--uic-scroll-picker-top-gradient);
      top: 0;
    }

    &::after {
      background-image: var(--uic-scroll-picker-bottom-gradient);
      bottom: 0;
    }
  }

  .select-options {
    color: var(--uic-scroll-picker-select-options-color);
    display: block;
    height: 0;
    margin: 0 auto;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .select-option {
    box-sizing: border-box;
    font-size: var(--uic-scroll-picker-selected-font-size);
    width: 100%;
  }

  .select-option__with-unit {
    padding-left: var(--uic-scroll-picker-unit-padding);
  }

  .highlight {
    background-color: var(--uic-color-white);
    border: var(--uic-scroll-picker-item-border);
    box-sizing: border-box;
    font-size: var(--uic-scroll-picker-selected-item-font-size);
    font-weight: var(--uic-scroll-picker-selected-item-font-weight);
    overflow: hidden;
    position: relative;
    width: 100%;
  }

  .highlight-item {
    box-sizing: border-box;
  }

  .highlight-item__with-unit {
    padding-left: var(--uic-scroll-picker-unit-padding);
  }

  .highlight-background {
    height: 100%;
    width: 100%;
  }

  .highlight-list {
    height: 100%;
    min-height: 40px;
    width: 100%;
  }

  .highlight-unit {
    font-size: var(--uic-scroll-picker-unit-font-size);
    font-weight: var(--uic-scroll-picker-unit-font-weight);
    padding-top: var(--uic-scroll-picker-unit-padding-top);
    position: absolute;
    right: var(--uic-scroll-picker-unit-padding);
  }

  .unit-placeholder {
    font-size: var(--uic-scroll-picker-selected-item-font-size);
    font-weight: var(--uic-scroll-picker-selected-item-font-weight);
    opacity: 0;
    padding-right: var(--uic-scroll-picker-unit-padding);
  }
}
